var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 91,
    viewBox: "0 0 96 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 94,
    height: 59,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 1L95 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L0.999997 61",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0744 21.6667L73.9217 21L72.4188 21.3442L72.6241 22.2408L62.0085 72.6652L63.5173 72.9828L73.4451 25.8256L83.9827 71.8397L85.4856 71.4955L74.2027 22.2268L74.3102 21.7164L74.0744 21.6667Z",
    fill: "#7ABB5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4969 46.3795L92.8423 46.2816L92.6723 45.6818L92.82 45.094L92.4815 45.0089L92.4218 44.7982L92.0559 44.9019L57.5544 36.2284L57.1785 37.7237L89.0834 45.7445L55.9999 55.122L56.4204 56.6054L92.0798 46.4977L92.4441 46.5893L92.4969 46.3795Z",
    fill: "#7ABB5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 0L55 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90L96 90",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 1L-2.86102e-06 1",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.f009d508894d200ccda555f872a9390e.svg";
export { ForwardRef as ReactComponent };